<template>
    <div class="config-card-block card sm-radius">
        <upload-file
            :title="title"
            :type="type"
            @show-progress="showProgress"
        ></upload-file>
    </div>
</template>

<script>
import uploadFile from '@/components/UploadFile.vue'
export default {
    components: {
        uploadFile,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            title: 'Bulk Customer Onboarding ',
            type: 'bulkCustomersOnboarding',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        // ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showProgress(value) {
            console.log('Bulk-Customer', value)
        },
    }, // End of Component > methods
} // End of export default
</script>
